import type { CSSProperties } from "react";
import { useTranslation } from "react-i18next";
import { Toaster as SonnerToaster, type ToasterProps } from "sonner";

import { IconCheckCircleFilled } from "@/components/_icons/IconCheckCircleFilled";
import { IconXCircleFilled } from "@/components/_icons/IconXCircleFilled";

const TOAST_COLORS = {
  "--normal-bg": "hsl(var(--popover))",
  "--normal-text": "hsl(var(--popover-foreground))",
  "--normal-border": "hsl(var(--border))",
} as CSSProperties;

export const Toaster = (props: ToasterProps) => {
  const { t } = useTranslation("common");

  return (
    <SonnerToaster
      theme="light"
      style={TOAST_COLORS}
      containerAriaLabel={t("a11y.notifications")}
      toastOptions={{ closeButtonAriaLabel: t("a11y.closeNotification") }}
      icons={{
        success: <IconCheckCircleFilled className="text-green-500" aria-hidden="true" />,
        error: <IconXCircleFilled className="text-rose-500" aria-hidden="true" />,
      }}
      {...props}
    />
  );
};
